import apiClient from '../utilities/api-client';

export const getOntologies = async () => apiClient.get(`/ontologies`);

export const getCrops = async (cropTerm) => apiClient.get(`/crops?term=${cropTerm}`);

export const getSemanticSuggestions = async (term) =>
	apiClient.get(`/semantic_suggestions?term=${term}`);
